import React, { FC, useEffect } from 'react'
import { yotpoStarNoReviews } from '../utils/yotpoStarNoReviews'
import { YotpoInView } from '../YotpoReviews/YotpoReviews'

declare global {
    interface Window {
        yotpo?: {
            refreshWidgets: () => void
            initialized?: boolean
            inview: YotpoInView
        }
    }
}

export type YotpoStarRatingProps = {
    enabled: boolean
    productId: string
    isPlp?: boolean
}

/**
 * Adds a div to the dom for Yotpo to embed product ratings.
 */
export const YotpoStarRating: FC<YotpoStarRatingProps> = ({
    enabled = false,
    productId,
    isPlp = false
}) => {
    useEffect(() => {
        if (enabled && typeof window !== 'undefined' && window.yotpo) {
            if (isPlp && window.yotpo?.inview) {
                window.yotpo.inview.allWidgetsAreReady = false
            }
            window.yotpo.refreshWidgets()
            if (isPlp) yotpoStarNoReviews()
        }
    }, [])

    if (!enabled) return null

    return (
        <div
            className={`yotpo bottomLine ${isPlp ? 'plpBottomLine' : ''}`}
            data-product-id={productId}
        />
    )
}
